<template>
  <div class="progress chart-progress" v-loading="!init">
    <div class="chart" v-if="init" style="padding-bottom: 120px">
      <h3>S кривая</h3>
      <div style="margin-bottom: 0px" v-for="comp in companies" :key="comp.label">
        <div style="display: flex; justify-content: center; flex: 1; width: 100%; margin-top: 30px">
          <strong class="label-chart" style="margin-bottom: 10px; text-align: center;">{{ comp.label }}</strong>
        </div>
        <div class="chart-container">
          <line-chart :width="size" :height="250"
                      v-if="init"
                      :chart-data="comp.chartData"
                      :options="chartOptions">
          </line-chart>
        </div>
        <div class="labels-custom" style="display: flex; align-items: center; margin-left: 20px">
          <span class="strong">План средняя: {{ fixed(comp.stat.planAvg) }}</span>
          <span class="strong">Факт средняя: {{ fixed(comp.stat.factAvg) }}</span>
          <span class="strong red"
                :style="{color: pStatus(comp.stat.percentagePlan), 'font-size': '24px', 'font-weight': 'bold'}"> {{
              isNaN(comp.stat.percentagePlan) ? 0 : fixed(comp.stat.percentagePlan)
            }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import LineChart from "./LineChart";
import {numberWithSpaces, toFixedWithoutZero} from "../../../utils/numberUtils";
import {apiUrl, isApiRuleIgnore} from "../../../plugins/firebase";
import axios from "axios";
import dayjs from "dayjs";
import DatePicker from "vue2-datepicker";

export default {
  name: "CurveS",
  components: {LineChart, DatePicker},
  data() {
    return {
      type: 'Исполнители',
      init: false,
      isCurrentPlan: false,
      stat: {},
      headCount: {},
      size: this.getSize(),
      datetimeRange: [
        new Date(String(dayjs().utc().subtract(14, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      chartData: {
        labels: [],
        datasets: [
          {
            pointRadius: 0,
            fill: false,
            pointHoverRadius: 0,
            label: 'План',
            borderWidth: 0,
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: '#f28a43',
            data: []
          },
          {
            pointRadius: 0,
            fill: false,
            borderWidth: 0,
            pointHoverRadius: 0,
            label: 'Факт',
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: '#34a4dc',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
          elements: {
            point:{
              radius: 1
            }
          },
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              fontSize: 10
            }
          }]
        }
      }
    }
  },
  async mounted() {
    await this.getAnalytics();
  },
  computed: {
    companies() {
      if (!this.headCount || !this.headCount.items) {
        return []
      }

      return Object.entries(this.headCount.items).map(([key, obj]) => {

        return ({
          label: key,
          stat: {
            planAvg: obj.planAvg,
            factAvg: obj.factAvg,
            percentagePlan: obj.percentagePlan,
          },
          chartData: {
            labels: this.chartData.labels,
            datasets: [
              {
                label: 'План',
                backgroundColor: 'rgba(0,0,0,0)',
                borderColor: '#f28a43',
                data: Object.values(obj.planByDate)
              },
              {
                label: 'Факт',
                backgroundColor: 'rgba(0,0,0,0)',
                borderColor: '#34a4dc',
                data: Object.values(obj.factByDate)
              }
            ]
          }
        })
      });
    },
  },
  watch: {
    isCurrentPlan() {
      this.getAnalytics();
    },
    type() {
      this.getAnalytics(this.type === 'Объекты');
    }
  },
  methods: {
    fixed(n) {

      if(isNaN(n)) {
        return 0
      }

      if(Infinity === n) {
        return  100
      }
      return parseFloat(Number(n).toFixed(0))
    },
    transformData(data) {
      try {
        if (data.length === 0) {
          return {
            "data": {
              "headcount": {
                "dates": [],
                "planByDate": {},
                "factByDate": {},
                "planAvg": 0,
                "factAvg": 0,
                "percentagePlan": 0,
                "items": {}
              }
            }
          };
        }

        const companies = {};
        let totalPlan = 0;
        let totalFact = 0;
        let totalCount = 0;

        const currentDate = dayjs();

        data.forEach(item => {
          const date = item.date.value.split('-').reverse().join('.');
          const {plan_cumulative, fact_cumulative, company} = item;

          if (!companies[company]) {
            companies[company] = {
              planByDate: {},
              factByDate: {},
              planTotal: 0,
              factTotal: 0,
              count: 0
            };
          }

          companies[company].planByDate[date] = plan_cumulative;
          companies[company].factByDate[date] = fact_cumulative;

          if (dayjs(item.date.value).isBefore(currentDate) || dayjs(item.date.value).isSame(currentDate)) {
            totalPlan += plan_cumulative;
            totalFact += fact_cumulative;
            totalCount++;
            companies[company].planTotal += plan_cumulative;
            companies[company].factTotal += fact_cumulative;
            companies[company].count++;
          }
        });

        const dates = Object.keys(companies[Object.keys(companies)[0]].planByDate);

        const headcount = {
          dates,
          planByDate: {},
          factByDate: {},
          planAvg: totalCount === 0 ? 0 : totalPlan / totalCount,
          factAvg: totalCount === 0 ? 0 : totalFact / totalCount,
          percentagePlan: totalPlan === 0 ? 0 : (totalFact / totalPlan) * 100,
          items: {}
        };

        dates.forEach(date => {
          let planSum = 0;
          let factSum = 0;

          for (let company in companies) {
            planSum += companies[company].planByDate[date];
            factSum += companies[company].factByDate[date];
          }

          headcount.planByDate[date] = planSum / Object.keys(companies).length;
          headcount.factByDate[date] = factSum / Object.keys(companies).length;
        });

        for (let company in companies) {
          headcount.items[company] = {
            planAvg: companies[company].count === 0 ? 0 : companies[company].planTotal / companies[company].count,
            factAvg: companies[company].count === 0 ? 0 : companies[company].factTotal / companies[company].count,
            percentagePlan: companies[company].planTotal === 0 ? 0 : (companies[company].factTotal / companies[company].planTotal) * 100,
            planByDate: companies[company].planByDate,
            factByDate: companies[company].factByDate
          };
        }

        return {data: {headcount}};
      } catch (e) {
        return {
          "data": {
            "headcount": {
              "dates": [],
              "planByDate": {},
              "factByDate": {},
              "planAvg": 0,
              "factAvg": 0,
              "percentagePlan": 0,
              "items": {}
            }
          }
        };
      }
    },
    numberWithSpaces,
    toFixedWithoutZero,
    getSize() {
      const size = window.screen.width;

      if (size < 460) {
        return size - 20;
      }

    },
    async getAnalytics() {
      setTimeout(async () => {
        this.init = false

        const dates = `%26uid%3D${authFirestore.currentUser.uid}`
        let url =   apiUrl + '//bigqueryFunctionSCurveByCompanies?projectId=' + this.$store.state.project.id + dates
        if(isApiRuleIgnore) {
          url =  apiUrl + '/bigqueryFunctionSCurveByCompanies?projectId=' + this.$store.state.project.id + `&uid=${authFirestore.currentUser.uid}`
        }


        try {
          const response = await axios(
            url,
            {
              uid: authFirestore.currentUser.uid,
              planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
              isCurrentPlan: this.isCurrentPlan
            },
          );

          const {data} = this.transformData(response.data)

          this.chartData.labels = data.headcount.dates;
          this.headCount = {...data.headcount}

          this.chartData.datasets = [
            {
              label: 'План',
              backgroundColor: 'rgba(0,0,0,0)',
              borderColor: '#f28a43',
              data: Object.values(data.headcount.planByDate)
            },
            {
              label: 'Факт',
              backgroundColor: 'rgba(0,0,0,0)',
              borderColor: '#34a4dc',
              data: Object.values(data.headcount.factByDate)
            }
          ]

          this.stat = {
            planAvg: data.headcount.planAvg,
            factAvg: data.headcount.factAvg,
            percentagePlan: data.headcount.percentagePlan,
          }
          this.init = true

        } catch (e) {
          this.chartData.labels = []
          this.headCount = {
              "dates": [],
              "planByDate": {},
              "factByDate": {},
              "planAvg": 0,
              "factAvg": 0,
              "percentagePlan": 0,
              "items": {}
          };
        }


        // this.analytics.priceJobs = data.priceJobs;
        //
        // let fact = this.analytics.priceJobs.plan ? this.analytics.priceJobs.percentagePlan : 100
        // let parse = [this.analytics.priceJobs.plan ? 100 : 0, fact || 0];
        //
        // if(!this.analytics.priceJobs.plan && !this.analytics.priceJobs.fact) {
        //   parse = [0,0]
        // }
        //
        // this.chartData.datasets[0].data = [parse[0], parse[1]]
        // this.chartData.labels = [`План ${parse[0]}`, `Факт ${parse[1]}`];
        this.init = true
      }, 1000)
    },
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 70) {
        return '#F57C00'
      }

      return '#D32F2F'
    }
  }
}
</script>

<style scoped lang="scss">
.progress {
  max-width: 600px;
  margin: 0 auto;
  // IOS ONLY REMOVE
  margin-top: -25px;

  .chart {
    margin: 0 auto;
    max-width: 460px;
    overflow: hidden;

    .percent {
      font-size: 18px;
      width: 100px;
      padding-left: 10px;
    }

    .chart-container {
      display: flex;
      align-items: center;
    }
  }
}

.chart-container-companies {
  min-width: 360px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .chart-company {
  }

}

.labels-custom {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  text-align: center;

  span {
    color: #000;
    font-size: 13px;
    margin-top: 12px;
    margin-right: 20px;
  }
}

.strong {
  font-weight: bold;
}


.label-chart {
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: calc(100% - 60px);
}
</style>
<style lang="scss">
.chart-progress {
  .el-radio-button__inner {
    width: 100px !important;
    padding: 12px 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/CurveS.vue